import { useContext, useState } from 'react';
import axios from 'axios';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import { postPresignedUrl } from './services';
import { useToast } from '@welbe/web-design-system';

export const useUploadFile = () => {
	const {
		jobRiskFactors,
		isLoading,
		focusedId,
		setJobRiskFactors,
		setLoading,
	} = useContext(JobProfileContext);
	const [error, setError] = useState(false);
	const { toast } = useToast();

	const index = jobRiskFactors.findIndex(
		(item) => item.jobProfileRiskFactor.id === focusedId,
	);
	const fileName = jobRiskFactors[index]?.jobProfileRiskFactor.hasFile
		? jobRiskFactors[index]?.jobProfileRiskFactor?.examFileName
		: '';

	const sendFile = async (file: any) => {
		try {
			const { data }: any = await postPresignedUrl(focusedId, file.name);
			await axios.put(data.content.url, file, {
				headers: { 'Content-Type': file.type },
			});
			toggleFileNameAttr(true);
		} catch (error: any) {
			setError(true);
			toast.error('Error al subir archivo!');
		}
	};

	const handleFile = async (file: any) => {
		if (file) {
			setLoading(true);
			await sendFile(file);
			setLoading(false);
		}
	};

	const handleClearFile = () => {
		toggleFileNameAttr(false);
		setError(false);
	};

	const toggleFileNameAttr = (state: boolean) => {
		if (jobRiskFactors[index]) {
			jobRiskFactors[index].jobProfileRiskFactor.hasFile = state;
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	return {
		jobRiskFactors,
		error,
		isLoading,
		fileName,
		handleFile,
		handleClearFile,
	};
};
